import Masonry from 'masonry-layout';

export default class Blog {
  constructor(section) {
    this.el = section.el;
    this.blogSelector = '[data-article-list]';
    this.imageSelector = '[data-rimg]';
    this.itemSelector = '[data-article-item]',
    this.columnWidth = '.article-item-grid-sizer',
    this.gutter = '.article-item-gutter-sizer',
    this.grid = null;

    this.blogMasonry = this.el.querySelector(this.blogSelector);
    this.blogImages = this.el.querySelectorAll(this.imageSelector);
    this.blogPosts = this.el.querySelectorAll(this.itemSelector);

    if (this.blogMasonry && this.blogPosts.length > 1) {
      this._blogMasonry();
    }
  }

  onSectionUnload() {
    for (let i = 0; i < this.blogImages.length; i += 1) {
      this.blogImages[i].removeEventListener('rimg:load', this._layoutGrid);
    }
    if (this.grid) {
      this.grid.destroy();
      this.grid = null;
    }
  }

  _blogMasonry() {
    // Set up masonry grid
    this.grid = new Masonry(this.blogMasonry, {
      itemSelector: this.itemSelector,
      columnWidth: this.columnWidth,
      gutter: this.gutter,
      percentPosition: true,
    });

    this._layoutGrid = this.grid.layout.bind(this.grid);

    for (let i = 0; i < this.blogImages.length; i += 1) {
      this.blogImages[i].addEventListener('rimg:load', this._layoutGrid);
    }
  }
}

